const path = require('path')
const Tone = require('tone')
const shuffle = require('./utility/shuffle.js')
const config = require('../audio/config.json')
const parcelFiles = require('../audio/**/*.mp3')

function getLibraryFiles() {
  console.log("parcelFiles", parcelFiles)
  let filePromises = Object.entries(parcelFiles)
    .map(([artist, files]) => {
      return Object.entries(files)
        .map(([id, filename]) => {
          return new Promise((resolve, reject) => {
            const player = new Tone.Player({
              url: filename,
              onload: () => resolve({
                id: id, file: player
              }),
              onerror: (error) => reject(error)
            }).toDestination()
          })
        })
    })

    filePromises = filePromises.reduce((acc, f) => {
      acc = acc.concat(f)
      return acc
    }, [])
    return Promise.all(filePromises)
}


module.exports = function loadStore(state, emitter) {
  state.samples = null
  state.files = null
  state.packs = null
  state.provisionPath = 'https://d1o75pijor3vl5.cloudfront.net/'
  state.sharedPack = null

  emitter.on('loadlibrary', () => {
    console.log('loadlibrary')
    state.packs = config.packs.filter(p => !p.hidden || p.id === state.theme || p.theme === state.theme)
    getLibraryFiles().then((files) => {
      console.log("files", files)
      let availableSamples = config.samples.filter(sample => 
        state.packs.find(p => p.samples.includes(sample.id)))
      state.files = files
      state.samples = availableSamples.map((sample) => {
        const fileEntry = state.files.find(f => f.id === sample.id)
        sample.file = fileEntry.file
        sample.file.onstop = () => { emitter.emit('render') }
        return sample
      })

      let startingPack = state.packs.find(p => p.id === state.theme || p.theme === state.theme)
      if (!startingPack){
        const shuffledPacks = state.packs.slice()
        shuffle(shuffledPacks)
        startingPack = shuffledPacks[0]
      }
      const themePacks = state.packs.filter(p => p.id === state.theme || p.theme === state.theme)
      state.packs = state.packs.filter(p => !themePacks.includes(p))
      state.packs = themePacks.concat(state.packs)
      emitter.emit('loadpack', startingPack)
    })
  })

  // Loads sample pack in json format
  emitter.on('loadpack', (pack) => {
    console.log('loadpack', pack)
    state.sampleBoard = pack.samples.slice()
    state.customSamplePack = false
    emitter.emit('unfocus')
    emitter.emit('render')
    setTimeout(() => emitter.emit('flashbuttons'), 10)
  })

}
